import React from "react";

import { DataContext } from "./../../context/DataContext";

import "./footer.scss";
import { useTranslation } from "react-i18next";

const Social = ({ socials }) => {
	return (
		<div className={`social`}>
			{socials.map((social, index) => (
				<a key={index} href={social.link} rel='noreferrer' target='_blank'>
					<img src={social.icona.url} alt={`Social icon`} />
				</a>
			))}
		</div>
	);
};

export const Footer = (moveToTop) => {
	const options = React.useContext(DataContext).options;
	const socials = options && options.acf.social_icons;
	const columns = options && options.acf.info;
	const { t } = useTranslation();

	return (
		<div className={`footer`}>
			<div className={`footer-grid`}>
				{columns &&
					columns.length > 0 &&
					columns.map((column, index) => (
						<div key={index} className={`footer-column`}>
							<div dangerouslySetInnerHTML={{ __html: column.body }} />
							{column.social_icons && <Social socials={socials} />}
						</div>
					))}
				<div className={`footer-grid-column`}>
					<p className={`_base`}>
						© {new Date().getFullYear()}
						<br />
						{t("footer_credits")}
						<br />
						<a
							href='https://www.iubenda.com/privacy-policy/28197277'
							target='_blank'
							rel='noreferrer'>
							Privacy policy
						</a>
					</p>
				</div>
			</div>
		</div>
	);
};
